import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
	name: "notification",
	initialState: {
		receivedNewNotification: false,
	},
	reducers: {
		setReceivedNewNotification(state, action) {
			state.receivedNewNotification = action.payload;
		},
	},
});

export const { setReceivedNewNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
